/**
 * Unit Conversion Utilities
 *
 * Conversions between imperial (miles, feet) and metric (meters) units.
 * Used for GPX route data: wizard displays imperial, DB stores metric.
 *
 * Epic: MVP 1.20.6-S - Key Locations Guided Editor
 * Story: SCRUM-830 (FIX-F08a: keyLocations save flow)
 */

const MILES_TO_METERS = 1609.344;
const FEET_TO_METERS = 0.3048;

/**
 * Convert miles to meters
 * @param {number} miles
 * @returns {number} Meters (rounded to nearest integer)
 */
export function milesToMeters(miles) {
  if (miles === null || miles === undefined || isNaN(miles)) {
    return 0;
  }
  return Math.round(miles * MILES_TO_METERS);
}

/**
 * Convert feet to meters
 * @param {number} feet
 * @returns {number} Meters (rounded to nearest integer)
 */
export function feetToMeters(feet) {
  if (feet === null || feet === undefined || isNaN(feet)) {
    return 0;
  }
  return Math.round(feet * FEET_TO_METERS);
}

/**
 * Convert meters to miles
 * @param {number} meters
 * @returns {number} Miles (2 decimal places)
 */
export function metersToMiles(meters) {
  if (meters === null || meters === undefined || isNaN(meters)) {
    return 0;
  }
  return Math.round((meters / MILES_TO_METERS) * 100) / 100;
}

/**
 * Convert meters to feet
 * @param {number} meters
 * @returns {number} Feet (rounded to nearest integer)
 */
export function metersToFeet(meters) {
  if (meters === null || meters === undefined || isNaN(meters)) {
    return 0;
  }
  return Math.round(meters / FEET_TO_METERS);
}
